/* eslint-disable no-console */
import { onError } from 'apollo-link-error'

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${path}`
      )
    )
  }
  if (networkError) {
    console.log(`[Network error]: ${JSON.stringify(networkError)}`)
  }
})

export default errorLink
